<template>
    <el-config-provider :locale="zhCn">
        <router-view v-if="isRouterActive" />
    </el-config-provider>
</template>

<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { provide, nextTick, ref } from 'vue'

const isRouterActive = ref(true)

provide('reload', () => {
    isRouterActive.value = false
    void nextTick(async () => {
        isRouterActive.value = true
    })
})
</script>
